export default __webpack_public_path__ + "static/1321-0a5fa5877df3228a0c4da25d187f400a.gif";